/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Home: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="home" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M680 1246.6666666666667L56.6666666666667 770.6666666666666L125.2333333333333 680.5666666666667L226.6666666666667 758.2V170H1020A113.3333333333333 113.3333333333333 0 0 1 1133.3333333333333 283.3333333333335V758.2L1234.7666666666667 681.1333333333334L1303.3333333333333 770.6666666666666L680 1246.6666666666667zM1020 283.3333333333335H340V844.3333333333334L680 1103.8666666666668L1020 844.3333333333334V283.3333333333335z" : "M544 997.3333333333334L45.3333333333333 616.5333333333333L100.1866666666667 544.4533333333333L181.3333333333334 606.56V136H816A90.6666666666667 90.6666666666667 0 0 1 906.6666666666669 226.6666666666667V606.56L987.8133333333334 544.9066666666668L1042.6666666666667 616.5333333333333L544 997.3333333333334zM816 226.6666666666667H272V675.4666666666667L544 883.0933333333334L816 675.4666666666667V226.6666666666667z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Home.displayName = `Blueprint5.Icon.Home`;
export default Home;
